import * as api from '../../api'

const getDefaultState = () => ({
  bagData: { data: [], status: false, loading: false },
  bagItemData: { data: [], status: false, loading: false },
  bagItemResult: { code: null, message: null, status: false, loading: false },
  bagItemCheckingHistory: { header: [], item: [], data: [], status: false, loading: false },
  departmentCodeData: { data: [], status: false, loading: false }
})

const state = getDefaultState()

const toThaiDate = (value) => new Date(value).toLocaleDateString('th-th')

const setRequestState = (commit, loadingMutation, statusMutation, loading, status) => {
  commit(loadingMutation, loading)
  commit(statusMutation, status)
}

const createResultPayload = (data) => ({
  code: data && typeof data.code !== 'undefined' ? data.code : null,
  message: data && typeof data.message !== 'undefined' ? data.message : null
})

const buildBagItemTable = (data) => {
  const itemsList = Array.isArray(data.items_list) ? data.items_list : []
  const checkResult = Array.isArray(data.items_check) && data.items_check[0]
    ? data.items_check[0].check_result || []
    : []

  const tableItem = itemsList.map((rawItem) => {
    const item = { ...rawItem, current_checking: '' }
    const matched = checkResult.find((row) => row.set_order === item.set_order)
    item.remain = matched ? matched.remain : 0
    item.suggest_order = item.quantity - item.remain
    if (item.suggest_order < 0) {
      item.suggest_order = 0
    }
    return item
  })

  return {
    ...data,
    tableItem
  }
}

const buildCheckingHistoryData = (data) => {
  if (!data) {
    return {
      header: [],
      item: [],
      data: []
    }
  }

  const header = [
    { text: 'รหัส', value: 'Matcode', sortable: false },
    { text: 'ชื่อรายการ', value: 'Generic_name', sortable: false },
    { text: 'จำนวนเต็ม', value: 'quantity', sortable: false },
    { text: 'หน่วย', value: 'BUN_label', sortable: false }
  ]

  if (Array.isArray(data.items_check)) {
    data.items_check.forEach((check, index) => {
      header.push({
        text: `ตรวจนับวันที่ ${toThaiDate(check.check_dt)}`,
        value: `d${index}`,
        date: check.check_dt,
        remark: check.check_comment,
        check_id: check.check_id,
        sortable: false
      })
    })
  } else {
    header.push({ text: 'ไม่มีประวัติการตรวจนับ', value: 'no_history' })
  }

  const itemsList = Array.isArray(data.items_list) ? data.items_list : []
  const item = itemsList.map((rawItem) => {
    const row = { ...rawItem }

    if (Array.isArray(data.items_check)) {
      data.items_check.forEach((check, checkIndex) => {
        const results = Array.isArray(check.check_result) ? check.check_result : []
        const matched = results.find((result) => result.set_order === row.set_order)
        row[`d${checkIndex}`] = matched ? matched.remain : 0
      })
      return row
    }

    row.d0 = 0
    row.d1 = 0
    row.d2 = 0
    return row
  })

  return {
    header,
    item,
    data
  }
}

const handleApiError = (error, commit, loadingMutation, statusMutation) => {
  setRequestState(commit, loadingMutation, statusMutation, false, false)
  console.log(error)
}

const createBagRequestPayload = (payload, token) => ({
  groupId: payload.groupId,
  setId: payload.setId,
  checkStart: payload.checkStart,
  userId: payload.userId,
  token
})

const mutations = {
  resetstate (currentState) {
    Object.assign(currentState, getDefaultState())
  },
  setBagData (currentState, data) {
    if (!Array.isArray(data)) {
      currentState.bagData.data = []
      return
    }

    currentState.bagData.data = data.map((row) => ({
      ...row,
      display_exp_date: toThaiDate(row.exp_date)
    }))
  },
  setBagDataLoading (currentState, data) {
    currentState.bagData.loading = data
  },
  setBagDataStatus (currentState, data) {
    currentState.bagData.status = data
  },
  setBagItemData (currentState, data) {
    if (!data) {
      currentState.bagItemData.data = []
      return
    }

    currentState.bagItemData.data = buildBagItemTable(data)
  },
  setBagItemDataLoading (currentState, data) {
    currentState.bagItemData.loading = data
  },
  setBagItemDataStatus (currentState, data) {
    currentState.bagItemData.status = data
  },
  setBagItemResult (currentState, data) {
    const payload = createResultPayload(data)
    currentState.bagItemResult.code = payload.code
    currentState.bagItemResult.message = payload.message
  },
  setBagItemResultLoading (currentState, data) {
    currentState.bagItemResult.loading = data
  },
  setBagItemResultStatus (currentState, data) {
    currentState.bagItemResult.status = data
  },
  setBagItemCheckingHistory (currentState, data) {
    const payload = buildCheckingHistoryData(data)
    currentState.bagItemCheckingHistory.header = payload.header
    currentState.bagItemCheckingHistory.item = payload.item
    currentState.bagItemCheckingHistory.data = payload.data
  },
  setBagItemCheckingHistoryLoading (currentState, data) {
    currentState.bagItemCheckingHistory.loading = data
  },
  setBagItemCheckingHistoryStatus (currentState, data) {
    currentState.bagItemCheckingHistory.status = data
  },
  setDepartmentCodeData (currentState, data) {
    currentState.departmentCodeData.data = data || []
  },
  setDepartmentCodeDataLoading (currentState, data) {
    currentState.departmentCodeData.loading = data
  },
  setDepartmentCodeDataStatus (currentState, data) {
    currentState.departmentCodeData.status = data
  }
}

const actions = {
  getBagData ({ rootState, commit }, payload) {
    setRequestState(commit, 'setBagDataLoading', 'setBagDataStatus', true, false)

    api.GetBag(
      createBagRequestPayload(payload, rootState.authen.token),
      (message) => {
        commit('setBagData', message.data)
        setRequestState(commit, 'setBagDataLoading', 'setBagDataStatus', false, true)
      },
      (error) => handleApiError(error, commit, 'setBagDataLoading', 'setBagDataStatus')
    )
  },
  initialBagItemData ({ commit }) {
    commit('setBagItemData', null)
  },
  getBagItemData ({ rootState, commit }, payload) {
    setRequestState(commit, 'setBagItemDataLoading', 'setBagItemDataStatus', true, false)

    api.GetBag(
      createBagRequestPayload(payload, rootState.authen.token),
      (message) => {
        if (Array.isArray(message.data) && message.data[0]) {
          commit('setBagItemData', message.data[0])
        } else {
          commit('setBagItemData', null)
        }
        setRequestState(commit, 'setBagItemDataLoading', 'setBagItemDataStatus', false, true)
      },
      (error) => handleApiError(error, commit, 'setBagItemDataLoading', 'setBagItemDataStatus')
    )
  },
  postBagItemData ({ rootState, commit }, payload) {
    setRequestState(commit, 'setBagItemResultLoading', 'setBagItemResultStatus', true, false)

    api.PostBag(
      { body: payload, token: rootState.authen.token },
      (message) => {
        commit('setBagItemResult', message.data)
        setRequestState(commit, 'setBagItemResultLoading', 'setBagItemResultStatus', false, true)
      },
      (error) => handleApiError(error, commit, 'setBagItemResultLoading', 'setBagItemResultStatus')
    )
  },
  getBagItemDataChecking ({ rootState, commit }, payload) {
    setRequestState(commit, 'setBagItemCheckingHistoryLoading', 'setBagItemCheckingHistoryStatus', true, false)

    api.GetBag(
      createBagRequestPayload(payload, rootState.authen.token),
      (message) => {
        if (Array.isArray(message.data) && message.data[0]) {
          commit('setBagItemCheckingHistory', message.data[0])
        } else {
          commit('setBagItemCheckingHistory', null)
        }
        setRequestState(commit, 'setBagItemCheckingHistoryLoading', 'setBagItemCheckingHistoryStatus', false, true)
      },
      (error) => handleApiError(error, commit, 'setBagItemCheckingHistoryLoading', 'setBagItemCheckingHistoryStatus')
    )
  },
  getDepartmentCodeData ({ rootState, commit }, payload) {
    setRequestState(commit, 'setDepartmentCodeDataLoading', 'setDepartmentCodeDataStatus', true, false)

    api.GetDepartmentCode(
      { groupId: payload, token: rootState.authen.token },
      (message) => {
        commit('setDepartmentCodeData', message.data)
        setRequestState(commit, 'setDepartmentCodeDataLoading', 'setDepartmentCodeDataStatus', false, true)
      },
      (error) => handleApiError(error, commit, 'setDepartmentCodeDataLoading', 'setDepartmentCodeDataStatus')
    )
  }
}

const getters = {
  bagItemsTable: (currentState) => {
    if (currentState.bagItemData.data && currentState.bagItemData.data.tableItem) {
      return currentState.bagItemData.data.tableItem
    }
    return []
  },
  hasBagItems: (currentState, getters) => getters.bagItemsTable.length > 0
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
